import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { checkAuthState } from '../api/apiService';

const LoginTest = () => {
  const { currentUser, userRole, error } = useAuth();
  const [authState, setAuthState] = useState({});
  const [localStorageInfo, setLocalStorageInfo] = useState({});

  useEffect(() => {
    // Check auth state on component mount
    const state = checkAuthState();
    setAuthState(state);

    // Get all auth-related localStorage items
    const storage = {
      token: localStorage.getItem('token'),
      userRole: localStorage.getItem('userRole'),
      isAuthenticated: localStorage.getItem('isAuthenticated'),
      userEmail: localStorage.getItem('userEmail')
    };
    setLocalStorageInfo(storage);
  }, []);

  // Helper function to render nested object properties
  const renderUserProperties = (userData) => {
    if (!userData) return null;
    
    return Object.entries(userData).map(([key, value]) => {
      // Skip rendering nested objects/arrays in detail
      if (typeof value === 'object' && value !== null) {
        return (
          <p key={key}>
            <strong>{key}:</strong> {JSON.stringify(value)}
          </p>
        );
      }
      return (
        <p key={key}>
          <strong>{key}:</strong> {value}
        </p>
      );
    });
  };

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h2>Login Status Test</h2>
      
      <div style={{ marginBottom: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
        <h3>Auth Context State</h3>
        <p><strong>Logged in:</strong> {currentUser ? 'Yes' : 'No'}</p>
        {currentUser && (
          <>
            <p><strong>User Role from Context:</strong> {userRole}</p>
            <h4>User Details:</h4>
            {renderUserProperties(currentUser)}
          </>
        )}
        {error && <p style={{ color: 'red' }}><strong>Error:</strong> {error}</p>}
      </div>

      <div style={{ marginBottom: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
        <h3>Auth State Utility Check</h3>
        <p><strong>Is Authenticated:</strong> {authState.isAuthenticated ? 'Yes' : 'No'}</p>
        <p><strong>Has Token:</strong> {authState.hasToken ? 'Yes' : 'No'}</p>
        <p><strong>User Role:</strong> {authState.userRole}</p>
      </div>

      <div style={{ padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
        <h3>localStorage Items</h3>
        <p><strong>Token exists:</strong> {localStorageInfo.token ? 'Yes' : 'No'}</p>
        <p><strong>User Role:</strong> {localStorageInfo.userRole}</p>
        <p><strong>Is Authenticated:</strong> {localStorageInfo.isAuthenticated}</p>
        <p><strong>User Email:</strong> {localStorageInfo.userEmail}</p>
      </div>
    </div>
  );
};

export default LoginTest; 